import { useQuery } from "@apollo/client"

import { COACH_TOOLS_API } from "../apolloClient"
import { MEMBER_APPLY_PATH_QUERY } from "../components/queries/memberApplicationEligibility"
import { flags, useFeatureFlags } from "../lib/feature-flags"
import { ELIGIBILITY_PATH } from "../utils/reciprocityApplication"

export { ELIGIBILITY_PATH }

/**
 * Reads which branch of Coach Tools `memberApplicationEligibility` applies.
 * `eligibilityPath` is that branch, for surfaces that show the candidate's
 * application instead of the apply action.
 * `canApplyViaReciprocity` is true only for an authorized reciprocity candidate
 * who is eligible to start a Member application, and only while the
 * applications-membership flag is on. Errors fail closed so the dashboard is
 * unchanged when Coach Tools is unavailable or lacks the field.
 */
export function useMemberApplyPath({ skip = false } = {}) {
  const [applicationsMembershipEnabled] =
    useFeatureFlags([flags.FLAG_FEAT_APPLICATIONS_MEMBERSHIP]) ?? []
  const skipQuery = skip || applicationsMembershipEnabled !== true

  const { data, loading } = useQuery(MEMBER_APPLY_PATH_QUERY, {
    context: { api: COACH_TOOLS_API },
    fetchPolicy: "network-only",
    errorPolicy: "all",
    skip: skipQuery,
  })

  const eligibility = data?.memberApplicationEligibility

  return {
    loading: skipQuery ? false : loading,
    eligibilityPath: skipQuery ? undefined : eligibility?.eligibilityPath,
    canApplyViaReciprocity:
      !skipQuery &&
      eligibility?.eligible === true &&
      eligibility?.eligibilityPath === ELIGIBILITY_PATH.RECIPROCITY,
  }
}
